import { css } from 'linaria';

export const icon = css`
  width: 40px;
  height: 40px;
  margin: 0 var(--space-200) 0 0;
`;

export const verticalIcon = css`
  margin-bottom: var(--space-150);
`;
